module.exports = __webpack_public_path__ + "img/leavy-banner-violet.68dc33ca.svg";